import { GroupAppointmentInfoDto } from '../dtos/groupappointmentinfo.dto';

export class GrouAppointmentModel{
    dto?: GroupAppointmentInfoDto;
    isChecked: boolean = false;

    constructor(input: GroupAppointmentInfoDto){
        this.dto = input;
    }
}